<template>
    <layout title="Outturn Detail">
        <div class="px-8 lg:grid lg:grid-cols-12 lg:gap-x-10">
            <section class="lg:col-span-12 mb-6">
                <outturn-header :outturn="item"></outturn-header>
            </section>
            <section class="lg:col-span-4">
                <outturn-details :outturn="item"></outturn-details>
                <outturn-monthly-price :outturn="item"></outturn-monthly-price>
                <outturn-averages :outturn="item"></outturn-averages>
            </section>
            <section class="lg:col-span-8">
                <outturn-totals :outturn="item"></outturn-totals>
                <outturn-tickets :outturn="item"></outturn-tickets>
            </section>
        </div>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import OutturnTickets from "@/Components/Outturn/OutturnTickets";
import OutturnHeader from "@/Components/Outturn/OutturnHeader";
import OutturnDetails from "@/Components/Outturn/OutturnDetails";
import OutturnMonthlyPrice from "@/Components/Outturn/OutturnMonthlyPrice";
import OutturnAverages from "@/Components/Outturn/OutturnAverages";
import OutturnTotals from "@/Components/Outturn/OutturnTotals";

export default {
    components: {
        OutturnTotals,
        OutturnAverages,
        OutturnMonthlyPrice,
        OutturnDetails,
        OutturnHeader,
        OutturnTickets,
        Layout
    },
    props: {
        item: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
        }
    },
}
</script>
